export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TopMenu.vue?vue&type=template&id=636f77a8"


//////////////////
// WEBPACK FOOTER
// ./src/components/top-menu/TopMenu.vue?vue&type=template&id=636f77a8
// module id = null
// module chunks = 